/* MOONLIGHT – Monatsbegleiter gratis (ab 100 € oder zu einem Set)
   Aufteilung:
   - Seitlicher Warenkorb (Opus Cart): zeigt das Geschenk selbst an. Dieses Skript
     hält sich dort raus und nimmt einen eingelegten Gratis-Begleiter wieder heraus,
     damit er nicht doppelt erscheint.
   - Warenkorb-Seite (/cart) und Klick auf „Zur Kasse“: Das Skript legt den
     Begleiter als echten Artikel ein. Kostenlos wird er durch die automatischen
     Shopify-Rabatte „Dein Monatsbegleiter gratis ab 100 €“ / „… zum Set“. */
(function () {
  'use strict';

 var GIFT_VARIANT_ID = 57832669184340;    // Monatsbegleiter – ZART (immer dasselbe Produkt)
  var THRESHOLD_CENTS = 10000;              // 100,00 € in Shop-Währung
  var GIFT_KEY = 'Geschenk';
  var GIFT_VALUE = 'Gratis ab 100 € Bestellwert';
  var GIFT_VALUE_SET = 'Gratis zu deinem Set';
  // Die 8 Sets (je ZART und mini), zu denen der Monatsbegleiter immer gratis dazugehört
  var SET_PRODUCT_IDS = [15816711962964, 15816733720916, 15816751481172, 15816771731796,
                         15816783495508, 15816798830932, 15816859779412, 15816898412884];
  var SIZE_KEY = 'Armumfang in cm - eng anliegend gemessen';
  var RELOAD_KEY = 'mlGiftReloads';

  var timer = null;
  var current = null;
  var lastCart = null;
  var failedThisPage = false;

  function url(name, fallback) {
    try { if (window.routes && window.routes[name]) return window.routes[name]; } catch (e) {}
    return fallback;
  }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function rate() {
    try { return parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) { return 1; }
  }
  function threshold() { return Math.round(THRESHOLD_CENTS * rate()); }
  function isGiftVariant(item) { return item.variant_id === GIFT_VARIANT_ID; }
  function isAutoGift(item) { return isGiftVariant(item); }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (currency || '€');
    }
  }
  function baseTotal(items) {
    return items.reduce(function (sum, item) {
      return isGiftVariant(item) ? sum : sum + (item.final_line_price || 0);
    }, 0);
  }
  function hasSet(items) {
    return items.some(function (i) { return SET_PRODUCT_IDS.indexOf(i.product_id) !== -1; });
  }
  function findSize(items) {
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties || {};
      for (var key in p) {
        if (/armumfang/i.test(key) && p[key] && String(p[key]).trim()) return String(p[key]).trim();
      }
    }
    return '';
  }

  function getCart() {
    return fetch(url('cart_url', '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }
  function addGift(items) {
    var props = {};
    props[GIFT_KEY] = baseTotal(items) >= threshold() ? GIFT_VALUE : GIFT_VALUE_SET;
    var size = findSize(items);
    if (size) props[SIZE_KEY] = size;
    return post(url('cart_add_url', '/cart/add') + '.js', {
      items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }]
    });
  }
  function changeLine(key, quantity) {
    return post(url('cart_change_url', '/cart/change') + '.js', { id: key, quantity: quantity });
  }

  /* mode 'show' = Geschenk als echten Artikel sicherstellen (Warenkorb-Seite, Kasse)
     mode 'hide' = eingelegtes Geschenk wieder herausnehmen (übrige Seiten mit Opus-Warenkorb) */
  function runSync(mode) {
    var changed = false;
    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var gifts = items.filter(isAutoGift);
        var paidGift = items.some(function (i) { return isGiftVariant(i) && !isAutoGift(i); });
        var qualifies = baseTotal(items) >= threshold() || hasSet(items);
        var action = null;

        if (mode === 'hide' || !qualifies) {
          if (gifts.length) action = changeLine(gifts[0].key, 0);
        } else if (gifts.length > 1) {
          action = changeLine(gifts[1].key, 0);
        } else if (gifts.length === 1 && gifts[0].quantity > 1) {
          action = changeLine(gifts[0].key, 1);
        } else if (!gifts.length && !paidGift && !failedThisPage) {
          action = addGift(items);
        }

        if (!action) return cart;
        return action
          .then(function () { changed = true; return getCart(); })
          .catch(function () { failedThisPage = true; return cart; });
      })
      .then(function (cart) {
        lastCart = cart;
        // Nach dem Herausnehmen kann es noch einen zweiten Gratis-Artikel geben → erneut prüfen
        if (changed && mode === 'hide' && (cart.items || []).some(isAutoGift)) return runSync('hide');
        if (onCartPage()) {
          if (changed) reloadCartPage();
          else { try { sessionStorage.setItem(RELOAD_KEY, '0'); } catch (e) {} }
        }
        ensureNote();
      })
      .catch(function () {});
  }

  function sync(mode) {
    current = Promise.resolve(current).then(function () { return runSync(mode); });
    return current;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { sync('show'); }, 250);
  }

  function reloadCartPage() {
    var reloads = 0;
    try { reloads = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10); } catch (e) {}
    if (reloads < 3) {
      try { sessionStorage.setItem(RELOAD_KEY, String(reloads + 1)); } catch (e) {}
      location.reload();
    }
  }

  /* ---------- Hinweis auf der Warenkorb-Seite ---------- */
  function noteHTML(cart) {
    var items = cart.items || [];
    if (!items.length) return '';
    var remaining = threshold() - baseTotal(items);
    if (remaining > 0 && hasSet(items)) {
      return '<p class="ml-gift-note__text">🎁 Zu deinem Set liegt dein Monatsbegleiter <strong>gratis</strong> bei</p>';
    }
    if (remaining > 0) {
      var pct = Math.max(4, Math.min(100, Math.round((1 - remaining / threshold()) * 100)));
      return '<p class="ml-gift-note__text">🎁 Noch <strong>' + money(remaining, cart.currency) +
        '</strong> bis zu deinem gratis Monatsbegleiter</p>' +
        '<div class="ml-gift-note__bar"><span style="width:' + pct + '%"></span></div>';
    }
    return '<p class="ml-gift-note__text">🎁 Dein Monatsbegleiter liegt deiner Bestellung <strong>gratis</strong> bei</p>';
  }
  function ensureNote() {
    if (!lastCart || !onCartPage()) return;
    var html = noteHTML(lastCart);
    document.querySelectorAll('#main-cart-footer .js-contents').forEach(function (target) {
      var existing = target.querySelector(':scope > .ml-gift-note');
      if (!html) { if (existing) existing.remove(); return; }
      if (existing && existing.getAttribute('data-html') === html) return;
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'ml-gift-note';
      el.setAttribute('data-html', html);
      el.innerHTML = html;
      target.insertBefore(el, target.firstChild);
    });
  }
  function injectStyles() {
    if (document.getElementById('ml-gift-style')) return;
    var css =
      '.ml-gift-note{background:#f6e9ec;border-radius:8px;padding:1rem 1.2rem;margin:0 0 1.2rem;text-align:left}' +
      '.ml-gift-note__text{margin:0;font-size:1.35rem;line-height:1.4;color:rgb(var(--color-foreground))}' +
      '.ml-gift-note__bar{height:6px;background:rgba(0,0,0,.08);border-radius:3px;margin-top:.8rem;overflow:hidden}' +
      '.ml-gift-note__bar span{display:block;height:100%;background:#c08497;border-radius:3px;transition:width .4s ease}';
    var style = document.createElement('style');
    style.id = 'ml-gift-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- Vor dem Weg zur Kasse: Geschenk als echten Artikel sicherstellen ---------- */
  var CHECKOUT_SEL = 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], ' +
    'button[class*="checkout" i], a[class*="checkout" i], button[id*="checkout" i]';
  var EXPRESS_SEL = '.shopify-payment-button, [data-shopify="payment-button"], ' +
    'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons';

  function checkoutUrl() {
    return url('cart_url', '/cart').replace(/\/cart\/?$/, '') + '/checkout';
  }
  function isCheckoutNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(CHECKOUT_SEL)) return true;
    if (node.matches && node.matches('input:not([type="submit"]), textarea, select, label, form')) return false;
    var text = (node.textContent || node.value || '').replace(/\s+/g, ' ').trim();
    return text.length <= 40 && /(zur kasse|^kasse$|^checkout$|zum checkout)/i.test(text);
  }

  // Auch Buttons in Shadow-DOM-Bereichen von Apps finden (composedPath)
  function findCheckoutEl(event) {
    var path = (event.composedPath && event.composedPath()) || [];
    if (!path.length) {
      for (var n = event.target; n; n = n.parentElement) path.push(n);
    }
    var checked = 0;
    for (var i = 0; i < path.length && checked < 8; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      checked++;
      if (isCheckoutNode(node)) return node;
    }
    return null;
  }

  function isExpress(event) {
    var path = (event.composedPath && event.composedPath()) || [];
    return path.some(function (n) { return n && n.nodeType === 1 && n.matches && n.matches(EXPRESS_SEL); });
  }

  function goToCheckout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    clearTimeout(timer);
    var done = false;
    var go = function () { if (done) return; done = true; window.location.href = checkoutUrl(); };
    setTimeout(go, 3000);                       // Sicherheitsnetz: nie länger als 3 Sek. warten
    sync('show').then(go, go);
  }

  document.addEventListener('click', function (event) {
    var el = findCheckoutEl(event);
    if (!el || el.disabled || isExpress(event)) return;
    goToCheckout(event);
  }, true);

  // Formulare, die zur Kasse schicken (z. B. Warenkorb-Formular mit „checkout“)
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    var submitter = event.submitter;
    var toCheckout = /\/checkout/.test(action) ||
      (/\/cart\/?$/.test(action) && submitter && submitter.name === 'checkout');
    if (toCheckout) goToCheckout(event);
  }, true);

  /* ---------- Start ---------- */
  function init() {
    if (onCartPage()) {
      injectStyles();
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);   // Mengenänderungen auf der Warenkorb-Seite
        }
      } catch (e) {}
      var noteTimer = null;
      new MutationObserver(function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(ensureNote, 50);
      }).observe(document.body, { childList: true, subtree: true });
      sync('show');
    } else {
      sync('hide');   // Opus-Warenkorb regelt die Anzeige selbst
    }
    // Zurück von der Kasse (Browser-Zurück): Zustand der Seite wiederherstellen
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) sync(onCartPage() ? 'show' : 'hide');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
